import React from 'react'
import { Outlet, Route, Routes } from 'react-router-dom'

import { APP_ROUTES, PERMISSIONS } from '../../common/constants'

import { PermissionRedirect } from '../../account/components/sections'

import { SopCreatePage, SopsPage } from './pages'

const SopsRouter = () => (
  <>
    <Routes>
      <Route
        index
        element={
          <PermissionRedirect permissions={PERMISSIONS.SOP.LIST}>
            <SopsPage />
          </PermissionRedirect>
        }
      />

      <Route
        path={APP_ROUTES.MISC.children.SOPS.children.SOP_CREATE.path}
        element={
          <PermissionRedirect permissions={PERMISSIONS.SOP.CREATE}>
            <SopCreatePage />
          </PermissionRedirect>
        }
      />
    </Routes>
    <Outlet />
  </>
)

export default SopsRouter
